import { useEffect, useState } from 'react';

export type DonutTier = 'sm' | 'md' | 'lg' | 'xl';

export function tierFromViewport(viewportWidth: number): DonutTier {
  if (viewportWidth <= 450) return 'sm';
  if (viewportWidth <= 1024) return 'md';
  if (viewportWidth <= 1440) return 'lg';
  return 'xl';
}

export function isStackedTier(tier: DonutTier): boolean {
  return tier === 'sm' || tier === 'lg';
}

export function isThreeColTier(tier: DonutTier): boolean {
  return tier === 'lg' || tier === 'xl';
}

export function useDonutTier(): DonutTier {
  const [tier, setTier] = useState<DonutTier>(() => (
    typeof window === 'undefined' ? 'lg' : tierFromViewport(window.innerWidth)
  ));
  useEffect(() => {
    const update = (): void => {
      setTier((prev) => {
        const next = tierFromViewport(window.innerWidth);
        return prev === next ? prev : next;
      });
    };
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return tier;
}
